module.exports = __webpack_public_path__ + "static/media/logout.45342ac7.svg";